import { useState, useEffect } from "react";
import type { Property } from "@/components/form-property/property-types";
import { PropertyCard } from "./PropertyCard";

// Função auxiliar para extrair nomes dos captadores diretamente
const getCaptadorNames = (captadores: any): string => {
	if (
		!captadores?.data ||
		!Array.isArray(captadores.data) ||
		captadores.data.length === 0
	) {
		return "N/A";
	}
	const names = captadores.data.map(
		(c: any) => c.attributes.username || `ID: ${c.id}`,
	);
	return names.join(", ");
};

interface PropertyCardWrapperProps {
	property: Property;
	cardProps: any;
}

export const PropertyCardWrapper = ({
	property,
	cardProps,
}: PropertyCardWrapperProps) => {
	const [captadorNames, setCaptadorNames] = useState<string>("Carregando...");

	useEffect(() => {
		const names = getCaptadorNames(property.attributes.captadores);
		setCaptadorNames(names);
	}, [property.attributes.captadores, property.id]);

	return <PropertyCard {...cardProps} captador={captadorNames} />;
};
